// 完成したときの動き（シャッター）（2026-10-21 に app.js から分けた）
import { $ } from './util.js';

// ---- 完成したときの動き: シャッター ----
// キャラの四角がカメラのフラッシュのように光り、写真を置くように画像が少し回って入って、白っぽいところから色がつく。
// 端末で「視差効果を減らす」などがオンなら動かさない（完成画面が出るだけ）。
// ほかに「キャラが完成画面へ移る＋チョコスプレー」「チョコの包み（金の箔とラベル）を開ける」も試して、シンプルなこれに決めた（ユーザー判断 2026-10-11）
export function flash() {
  const f = document.createElement('div');
  f.className = 'stage-flash';
  $('stage').appendChild(f);
  f.animate([{ opacity: 0 }, { opacity: .95, offset: .18 }, { opacity: 0 }], { duration: 420, easing: 'ease-out' })
    .finished.catch(() => {}).then(() => { f.remove(); });
  // 光りきったところで完成画面へ（光が消えていくのは完成画面の後ろ）
  return new Promise((resolve) => { setTimeout(resolve, 120); });
}
// 動きが終わったら解決する（色がつききるまで）
export function photoIn() {
  $('chaMakeResultImage').animate([
    { transform: 'translateY(-26px) rotate(-7deg) scale(1.06)', opacity: 0 },
    { opacity: 1, offset: .3 },
    { transform: 'none', opacity: 1 }
  ], { duration: 600, easing: 'cubic-bezier(.3, 1.35, .45, 1)' });
  const color = $('chaMakeResultImageView').animate([
    { filter: 'brightness(1.9) saturate(0)' },
    { filter: 'brightness(1.9) saturate(0)', offset: .25 },
    { filter: 'none' }
  ], { duration: 1200, easing: 'ease-out' });
  popTitle();
  return color.finished ? color.finished.catch(() => {}) : new Promise((resolve) => { setTimeout(resolve, 1200); });
}
export function popTitle() {
  $('finishTitle').animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)', offset: .35 }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
}
